import { VuiFormItem } from "../../../../@vendor/components";
import { ICounselingForm } from "../interface";
import { useTranslation } from "react-i18next";
import { Input } from "antd";
import CounselingFormLabel from "../Label";

const { TextArea } = Input;

const CounselingFormParagraph = ({ question }: ICounselingForm) => {
  const { t } = useTranslation();

  return (
    <VuiFormItem
      rules={[
        {
          required: question.is_required,
          message: t("validation.required", {
            item: question.question,
          }),
        },
      ]}
      name={String(question.id)}
      label={
        <CounselingFormLabel
          label={question.question}
          isRequired={question.is_required}
        />
      }
    >
      <TextArea rows={3} />
    </VuiFormItem>
  );
};

export default CounselingFormParagraph;
